import { mockCheckoutContracts } from './checkout-contracts.mock';

export const mockCheckoutOffers = [
  {
    offerReference: '1234',
    offerId: 124543,
    contracts: [mockCheckoutContracts],
  },
];
